module.exports = __webpack_public_path__ + "static/img/2023_9_8_7.6ab4e4d9.6ab4e4d.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/img/2023_9_8_7.6ab4e4d9.jpg
// module id = /42z
// module chunks = 0